
import {default as UnitMapObject} from '../UnitMap'

class UnitMap {

  constructor(element, options = {}) {

    const map = new UnitMapObject(element, options)

    // Load interface
    
    this.load = function (url, callback) {
      map.load(url, callback)
      return this
    }

    this.document = function(doc) {
      map.document(doc)
      return this
    }

    // Expand / Collapse Levels interface
    
    this.expand = function (options = {}) {
      map.expand(options)
      return this
    }

    this.collapse = function () {
      map.collapse()
      return this
    }

    // Selection interface
    
    this.select = function (selector) {
      return map.select(selector)
    }

    // 2D Transform interface
    
    this.transition = function (properties, duration = 350, ease = 'cubic-in-out') {
      model.transition(properties, duration, ease)
      return this
    }

    this.translate = function (x, y) {
      map.translate(x, y)
      return this
    }

    this.panZoom = function (enabled = true) {
      map.panZoom(enabled)
      return this
    }

    this.autoScale = function (autoScale) {
      map.autoScale(autoScale)
      return this
    }

    // Event interface

    this.on = function (event, callback, context) {
      map.on(event, callback, context)
      return this
    }

    this.off = function (event, callback, context) {
      map.off(event, callback, context)
      return this
    }

    this.once = function (event, callback, context) {
      map.once(event, callback, context)
      return this
    }
  }
}

export default UnitMap
